import gql from 'graphql-tag';
import moment from 'moment';
import deepFreeze from 'deep-freeze';
import { apolloClient } from '@/apollo/apollo';
import parseDates from '@/functions/parseDates';

import * as actions from '@/constants/actions';

export default {
    data() {
        return {
            gettingData: false,
            dataQuery: gql`query stationSWChem($id: Int!) {
                getStation(id: $id) {
                    name
                    nid
                    net
                    yr
                    ty
                    established_date
                    licence_link
                    location_purpose
                    location_type
                    description
                    chemistry {
                      sparkline
                    }
                }
            }`,
            showSingleChartModal: false,
            queryDone: false,
            queryData: {},
            chemistryData: {},
            chemistryQuery: gql`query chemistryQuery {
                getChemistryLookup {
                    display
                    variable
                }
            }`,
            chartData: [],
            sparklineData: [],
            properties: [],
        };
    },
    methods: {
        /**
         * query the API and fetch station data
         */
        async getData() {
            if (!this.station) return;
            this.queryDone = false;
            this.$store.dispatch(actions.ADD_LOADING, 'load station data');
            try {
                const { data } = await apolloClient.query({
                    query: this.dataQuery,
                    variables: { id: this.station.id },
                });

                // populate variables
                this.queryData = data.getStation;
                // parse date values and re-freeze query results
                const sparklineData = this.queryData.chemistry.sparkline.map((e) => {
                    const newObj = Object.assign({}, e);
                    newObj.data = parseDates(e.data);
                    return newObj;
                });
                this.sparklineData = deepFreeze(sparklineData);
            } catch (ex) {
                this.$store.dispatch(actions.TRIGGER_TOAST, 'Error retrieving station data');
            }

            this.queryDone = true;
            this.buildProps();

            // format chemistry data for charts
            this.chartData = this.queryData.chemistry.formatted_chemistry_chart_data;
            this.$store.dispatch(actions.REMOVE_LOADING, 'load station data');
        },
        /**
         * build an array of properties to display
         */
        buildProps() {
            const data = this.queryData;
            const properties = [];

            properties.push({
                title: 'Description',
                value: data.description,
            });

            if (data.established_date) {
                const establishedDate = moment(data.established_date)
                    .format('YYYY-MM-DD');

                properties.push({
                    title: 'Established',
                    value: establishedDate,
                });
            }

            properties.push({
                title: 'Location Purpose',
                value: data.location_purpose,
            });

            properties.push({
                title: 'Location Type',
                value: data.location_type,
            });

            this.properties = properties;
        },
    },
    computed: {
        station() {
            return this.$store.state.map.selectedStation;
        },
        name() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.name;
        },
        networkUrl() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.licence_link;
        },
        network() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.net;
        },
        networkId() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.nid;
        },
        type() {
            if (!this.queryDone) {
                return '';
            }
            return this.queryData.ty;
        },
        years() {
            if (!this.queryDone) {
                return [];
            }
            return this.queryData.yr;
        },
        numYears() {
            if (this.years.length === 2) {
                const years = this.years[1] - this.years[0];
                return years + 1;
            }
            return 0;
        },
    },
    watch: {
        async station(newStation, oldStation) {
            if (this.gettingData === newStation.id) {
                return;
            }
            this.gettingData = newStation.id;
            if (oldStation === null || (newStation && oldStation.id !== newStation.id)) {
                await this.getData();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/surfaceQualityData.js